<template>
    <div>
        <top :keyword="''" :tab="'study'"></top>
        <div class="studyMain">
            <div class="instudyMain">
                <div v-if="hasRecord" style="margin-top:100px;">
                    暂无学习记录，请先
                    <span class="denglu" @click="logIn">登录</span>
                </div>
                <div class="study" v-else>
                    <el-container>
                        <el-aside width="200px">
                            <div class="picture">
                                <el-avatar
                                    :src="userInfo.picture"
                                    style="position: relative;height: 100%;"
                                ></el-avatar>
                            </div>
                            <span>{{userInfo.realName || userInfo.name}}</span>
                            <p
                                v-for="(text,index) in texts"
                                :key="index"
                                @click="active = text.key"
                                :class="{active: text.key === active}"
                                style="cursor: pointer;"
                            >{{text.name}}</p>
                            <p>
                                <a target="_blank" @click="change">修改密码</a>
                            </p>
                            <p>
                                <a :href="onlineStudy" target="_blank">线上学习</a>
                            </p>
                        </el-aside>
                        <el-main>
                            <div class="main">
                                <component v-bind:is="active"></component>
                            </div>
                        </el-main>
                        <div class="a" v-if="dialogTableVisible">
                            <el-dialog
                                title="修改密码"
                                :visible.sync="dialogTableVisible"
                                center
                                :append-to-body="true"
                                :lock-scroll="false"
                                width="30%"
                                style="height:600px;margin-top:100px;"
                            >
                                <Forgetpass @close="dialogTableVisible = false"></Forgetpass>
                            </el-dialog>
                        </div>
                    </el-container>
                </div>
            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import top from '../top'
import myClass from '../mySpace/myClass'
import upcomingCourse from '../mySpace/upcomingCourse'
import learnRecord from '../mySpace/learnRecord'
import information from '../mySpace/information'
import bottom from '../bottom'
import Forgetpass from '../student/Forgetpass'

export default {
    name: 'study',
    data() {
        return {
            texts: [
                { name: '申请班级', key: 'myClass' },
                { name: '我的学习', key: 'upcomingCourse' },
                { name: '学习记录', key: 'learnRecord' },
                { name: '个人信息', key: 'information' }
            ],
            active: '',
            dialogTableVisible: false
        }
    },
    created() {
        this.active = this.texts[0].key
    },
    computed: {
        userInfo() {
            return this.$store.state.user || {}
        },
        hasRecord() {
            return !this.userInfo.id
        },
        onlineStudy() {
            return (
                this.$studentPath +
                '/loginValid/token-login?token=' +
                this.$store.state.Authorization
            )
        }
    },
    methods: {
        logIn() {
            this.$router.push('/student/login')
        },
        // 选项卡
        textClick(text, $event) {
            this.active = text.key
        },
        change() {
            this.dialogTableVisible = true
        }
    },
    components: {
        bottom: bottom,
        top: top,
        myClass,
        upcomingCourse,
        learnRecord,
        information,
        Forgetpass
    }
}
</script>
<style scoped>
@import '../../assets/css/iconfont.css';
@import '../../assets/css/common.css';
@import '../../assets/css/index.css';
@import '../../assets/css/cms.css';
.denglu {
    text-decoration: underline;
    color: #3ab57e;
    cursor: pointer;
}
.studyMain {
    width: 100%;
    height: 800px;
}
.instudyMain {
    width: 1184px;
    height: 100%;
    background: #fff;
    margin: 20px auto;
    position: relative;
}
.el-container {
    height: auto !important;
}
.el-aside {
    background-color: #fff;
    color: #333;
    text-align: center;
    width: 200px;
    height: 700px;
    position: absolute;
    left: 0;
    border: 1px solid #eee;
    box-shadow: 4px 4px 10px #eee;
    /* line-height: 200px; */
}
.picture {
    width: 150px;
    height: 150px;
    margin: 0 auto;
    background: #eee;
    border-radius: 50%;
    margin-top: 20px;
    margin-bottom: 10px;
}
/* .class{
    position: absolute;
  } */
.el-aside span {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: center;
}
.el-aside p {
    width: 100%;
    height: 50px;
    text-align: center;
    line-height: 50px;
    /* background-color: #fff; */
}
.el-aside p:last-child {
    cursor: pointer;
}
.el-container {
    width: 1184px;
    height: 750px;
    float: right;
    margin-bottom: 40px;
}
.el-main {
    color: #333;
    text-align: center;
    height: auto;
    width: 984px;
    overflow: hidden;
    float: right;
}
.el-main::-webkit-scrollbar {
    display: none;
}
.el-dialog {
    height: 400px !important;
}
.el-upload-list el-upload-list--picture {
    margin: 0;
    padding: 0;
    list-style: none;
    width: 400px !important;
    margin-left: 41px;
}
input#input1 {
    background: #ccc;
}
.hide .el-upload--picture-card {
    display: none;
}
.hides .el-upload--picture-card {
    display: none;
}
.active {
    color: #3ab57f;
}
</style>



// WEBPACK FOOTER //
// src/views/mySpace/profile.vue